var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_8141_32044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.75 13.125H1.75C1.26602 13.125 0.875 12.734 0.875 12.25V1.75C0.875 1.26602 1.26602 0.875 1.75 0.875H5.25V3.9375C5.25 4.66211 5.83789 5.25 6.5625 5.25H9.625V12.25C9.625 12.734 9.23398 13.125 8.75 13.125ZM6.5625 4.375C6.32188 4.375 6.125 4.17812 6.125 3.9375V0.888672C6.20156 0.907812 6.27266 0.946094 6.32734 1.00352L9.49648 4.17266C9.55391 4.23008 9.59219 4.29844 9.61133 4.375H6.5625ZM1.75 0C0.784766 0 0 0.784766 0 1.75V12.25C0 13.2152 0.784766 14 1.75 14H8.75C9.71523 14 10.5 13.2152 10.5 12.25V4.48164C10.5 4.13437 10.3605 3.80078 10.1145 3.55469L6.94805 0.385547C6.70195 0.139453 6.36836 0 6.02109 0H1.75ZM5.6875 6.5625C5.6875 6.32188 5.49062 6.125 5.25 6.125C5.00938 6.125 4.8125 6.32188 4.8125 6.5625V9.88203L3.37148 8.44102C3.20195 8.27148 2.92305 8.27148 2.75352 8.44102C2.58398 8.61055 2.58398 8.88945 2.75352 9.05898L4.94102 11.2465C5.11055 11.416 5.38945 11.416 5.55898 11.2465L7.74648 9.05898C7.91602 8.88945 7.91602 8.61055 7.74648 8.44102C7.57695 8.27148 7.29805 8.27148 7.12852 8.44102L5.6875 9.88203V6.5625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8141_32044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.f4a0e28afc47f4d9225fcdd6ea38aa20.svg";
export { ForwardRef as ReactComponent };